export default __webpack_public_path__ + "static/media/shirtly-premium-logo.5ce006d3.png";